import React, { type PropsWithChildren, memo } from "react";
import ComboboxVariant, { type ComboboxVariants } from "./Combobox.styles";
import * as Styles from "./Combobox.styles";

export type ComboboxVariantsType = keyof typeof ComboboxVariants;

export type ComboboxType = {
    variant: ComboboxVariantsType;
    box: JSX.Element;
    list: JSX.Element;
    id: string;
};

const Combobox: React.FC<PropsWithChildren<ComboboxType>> = (props) => {
    const { variant, box, list, id } = props;

    return (
        <ComboboxVariant variant={variant}>
            <Styles.Box>{box}</Styles.Box>
            <Styles.List id={id} role="listbox">
                {list}
            </Styles.List>
        </ComboboxVariant>
    );
};

export default memo(Combobox);
